import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {useAccountApplication} from "../../account-applications/hooks/useAccountApplication";
import {AccountApplicationStatus} from "../../account-applications/types";
import {Application} from "../types.ts";
import {AiOutlineCheck} from 'react-icons/ai';

export const EnableRecordButton = ({
                                       record
                                   }: {
    record: Application
}) => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('User account not found');
    }
    const {createRecord} = useAccountApplication(userAccount.id)

    const onClick = () => {
        createRecord({
                         accountId: userAccount.id,
                         applicationId: record.id,
                         // FNP-899: REQUIRED, not decorative. console-api treats a
                         // row without an ACTIVE status as "not a seat" and emits no
                         // seat-occupancy-started, so the enable never opens a
                         // SeatOccupancy interval and a per-seat plan under-bills
                         // silently. The UI looks correct either way — which is why
                         // this went unnoticed.
                         accountApplicationStatus: AccountApplicationStatus.ACTIVE,
                     });
    };
    return (
        <FlexiButton
            leftSection={<AiOutlineCheck/>}
            onClick={onClick}
            size={'md'}
        >
            {I18n.get('Enable')}
        </FlexiButton>
    );
};
